import { render } from "./publicity.vue?vue&type=template&id=c4e4f892&scoped=true"
import script from "./publicity.vue?vue&type=script&lang=js"
export * from "./publicity.vue?vue&type=script&lang=js"

import "./publicity.vue?vue&type=style&index=0&id=c4e4f892&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e4f892"]])

export default __exports__